(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mithril"));
	else if(typeof define === 'function' && define.amd)
		define("mithrilmdl", ["mithril"], factory);
	else if(typeof exports === 'object')
		exports["mithrilmdl"] = factory(require("mithril"));
	else
		root["mithrilmdl"] = factory(root["m"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 30);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlBase = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//kann hier eigtl. weg, oder in children weg

var MdlBase = exports.MdlBase = function () {
    function MdlBase() {
        _classCallCheck(this, MdlBase);

        this.classList = [];
        this.id;
    }

    _createClass(MdlBase, [{
        key: 'oninit',
        value: function oninit(vnode) {
            //??? recheck
            // if (vnode.attrs.class) {
            //     let classes = vnode.attrs.class.split(" ");
            //     this.classList = this.classList.concat(classes);
            // }

            //todo
            this.id = vnode.attrs.id ? vnode.attrs.id : null;

            vnode.attrs.color ? this.classList.push('mdl-color-text--' + vnode.attrs.color) : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {}
    }]);

    return MdlBase;
}();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlIcon = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlIcon = exports.MdlIcon = function (_MdlBase) {
    _inherits(MdlIcon, _MdlBase);

    function MdlIcon() {
        _classCallCheck(this, MdlIcon);

        return _possibleConstructorReturn(this, (MdlIcon.__proto__ || Object.getPrototypeOf(MdlIcon)).apply(this, arguments));
    }

    _createClass(MdlIcon, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlIcon.prototype.__proto__ || Object.getPrototypeOf(MdlIcon.prototype), 'oninit', this).call(this, vnode);

            this.customClassList = [];
            this.customClassList = vnode.attrs.class ? vnode.attrs.class.split(" ") : null;
            this.classList.push("material-icons");
            vnode.attrs.avatar ? this.classList.push("mdl-list__item-avatar") : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            var attributes = {};
            vnode.attrs.onclick ? attributes.onclick = function (e) {
                return vnode.attrs.onclick(e);
            } : null;

            this.classList = [];
            //add custom classes back in
            if (this.customClassList) this.classList = this.classList.concat(this.customClassList);

            this.classList.push("material-icons");
            vnode.attrs.color ? this.classList.push('mdl-color-text--' + vnode.attrs.color) : null;
            vnode.attrs.avatar ? this.classList.push("mdl-list__item-avatar") : null;

            return (0, _mithril2.default)(
                'i',
                _extends({
                    'class': this.classList.join(" ")
                }, attributes),
                vnode.attrs.icon ? vnode.attrs.icon : vnode.children
            );
        }
    }]);

    return MdlIcon;
}(_mdlBase.MdlBase);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlButton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlIcon = __webpack_require__(2);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlButton = exports.MdlButton = function (_MdlBase) {
    _inherits(MdlButton, _MdlBase);

    function MdlButton() {
        _classCallCheck(this, MdlButton);

        return _possibleConstructorReturn(this, (MdlButton.__proto__ || Object.getPrototypeOf(MdlButton)).apply(this, arguments));
    }

    _createClass(MdlButton, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlButton.prototype.__proto__ || Object.getPrototypeOf(MdlButton.prototype), 'oninit', this).call(this, vnode);

            this.classList.push("mdl-button", "mdl-js-button", "mdl-js-ripple-effect");
            vnode.attrs.raised ? this.classList.push("mdl-button--raised") : null;
            vnode.attrs.colored ? this.classList.push("mdl-button--colored") : null;
            vnode.attrs.accent ? this.classList.push("mdl-button--accent") : null;
            vnode.attrs.icon && !vnode.attrs.fab ? this.classList.push("mdl-button--icon") : null;
            vnode.attrs.fab ? this.classList.push("mdl-button--fab") : null;
            vnode.attrs.minifab ? this.classList.push("mdl-button--mini-fab") : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            var attributes = {};
            vnode.attrs.onclick ? attributes.onclick = function (e) {
                return vnode.attrs.onclick(e);
            } : null;

            return (0, _mithril2.default)(
                'button',
                _extends({
                    type: vnode.attrs.type ? vnode.attrs.type : "button",
                    'class': this.classList.join(" ")
                }, attributes),
                vnode.attrs.icon && vnode.children.length == 0 ? (0, _mithril2.default)(_mdlIcon.MdlIcon, { icon: vnode.attrs.icon }) : vnode.attrs.title ? vnode.attrs.title : vnode.children
            );
        }
    }]);

    return MdlButton;
}(_mdlBase.MdlBase);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlLayoutSpacer = exports.MdlLayoutDrawer = exports.MdlLayoutContent = exports.MdlLayoutTitle = exports.MdlLayoutHeaderRow = exports.MdlLayoutHeader = exports.MdlLayout = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

var _mdlNavigation = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlLayout = exports.MdlLayout = function (_MdlBase) {
    _inherits(MdlLayout, _MdlBase);

    function MdlLayout() {
        _classCallCheck(this, MdlLayout);

        return _possibleConstructorReturn(this, (MdlLayout.__proto__ || Object.getPrototypeOf(MdlLayout)).apply(this, arguments));
    }

    _createClass(MdlLayout, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlLayout.prototype.__proto__ || Object.getPrototypeOf(MdlLayout.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-layout", "mdl-js-layout", "mdl-layout--fixed-header", "mdl-layout--no-drawer-button");

            vnode.attrs.fixedDrawer && vnode.attrs.fixedDrawer != false ? this.classList.push("mdl-layout--fixed-drawer") : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlLayout;
}(_mdlBase.MdlBase);

var MdlLayoutHeader = exports.MdlLayoutHeader = function (_MdlBase2) {
    _inherits(MdlLayoutHeader, _MdlBase2);

    function MdlLayoutHeader() {
        _classCallCheck(this, MdlLayoutHeader);

        return _possibleConstructorReturn(this, (MdlLayoutHeader.__proto__ || Object.getPrototypeOf(MdlLayoutHeader)).apply(this, arguments));
    }

    _createClass(MdlLayoutHeader, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlLayoutHeader.prototype.__proto__ || Object.getPrototypeOf(MdlLayoutHeader.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-layout__header");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'header',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlLayoutHeader;
}(_mdlBase.MdlBase);

var MdlLayoutHeaderRow = exports.MdlLayoutHeaderRow = function (_MdlBase3) {
    _inherits(MdlLayoutHeaderRow, _MdlBase3);

    function MdlLayoutHeaderRow() {
        _classCallCheck(this, MdlLayoutHeaderRow);

        return _possibleConstructorReturn(this, (MdlLayoutHeaderRow.__proto__ || Object.getPrototypeOf(MdlLayoutHeaderRow)).apply(this, arguments));
    }

    _createClass(MdlLayoutHeaderRow, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlLayoutHeaderRow.prototype.__proto__ || Object.getPrototypeOf(MdlLayoutHeaderRow.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-layout__header-row");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlLayoutHeaderRow;
}(_mdlBase.MdlBase);

var MdlLayoutTitle = exports.MdlLayoutTitle = function (_MdlBase4) {
    _inherits(MdlLayoutTitle, _MdlBase4);

    function MdlLayoutTitle() {
        _classCallCheck(this, MdlLayoutTitle);

        return _possibleConstructorReturn(this, (MdlLayoutTitle.__proto__ || Object.getPrototypeOf(MdlLayoutTitle)).apply(this, arguments));
    }

    _createClass(MdlLayoutTitle, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlLayoutTitle.prototype.__proto__ || Object.getPrototypeOf(MdlLayoutTitle.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-layout-title");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'span',
                { 'class': this.classList.join(" ") },
                vnode.attrs.title ? vnode.attrs.title : vnode.children
            );
        }
    }]);

    return MdlLayoutTitle;
}(_mdlBase.MdlBase);

var MdlLayoutContent = exports.MdlLayoutContent = function (_MdlBase5) {
    _inherits(MdlLayoutContent, _MdlBase5);

    function MdlLayoutContent() {
        _classCallCheck(this, MdlLayoutContent);

        return _possibleConstructorReturn(this, (MdlLayoutContent.__proto__ || Object.getPrototypeOf(MdlLayoutContent)).apply(this, arguments));
    }

    _createClass(MdlLayoutContent, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlLayoutContent.prototype.__proto__ || Object.getPrototypeOf(MdlLayoutContent.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-layout__content");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'main',
                { 'class': this.classList.join(" ") },
                (0, _mithril2.default)(
                    'div',
                    { 'class': 'page-content' },
                    vnode.children
                )
            );
        }
    }]);

    return MdlLayoutContent;
}(_mdlBase.MdlBase);

var MdlLayoutDrawer = exports.MdlLayoutDrawer = function (_MdlBase6) {
    _inherits(MdlLayoutDrawer, _MdlBase6);

    function MdlLayoutDrawer() {
        _classCallCheck(this, MdlLayoutDrawer);

        return _possibleConstructorReturn(this, (MdlLayoutDrawer.__proto__ || Object.getPrototypeOf(MdlLayoutDrawer)).apply(this, arguments));
    }

    _createClass(MdlLayoutDrawer, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlLayoutDrawer.prototype.__proto__ || Object.getPrototypeOf(MdlLayoutDrawer.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-layout__drawer");
        }
    }, {
        key: 'oncreate',
        value: function oncreate() {
            var mdlLayout = document.querySelector(".mdl-layout");
            mdlLayout.classList.remove("mdl-layout--no-drawer-button");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': this.classList.join(" ") },
                (0, _mithril2.default)(
                    'span',
                    { 'class': 'mdl-layout-title mdl-color--primary mdl-color-text--white' },
                    vnode.attrs.title
                ),
                vnode.children
            );
        }
    }]);

    return MdlLayoutDrawer;
}(_mdlBase.MdlBase);

var MdlLayoutSpacer = exports.MdlLayoutSpacer = function (_MdlBase7) {
    _inherits(MdlLayoutSpacer, _MdlBase7);

    function MdlLayoutSpacer() {
        _classCallCheck(this, MdlLayoutSpacer);

        return _possibleConstructorReturn(this, (MdlLayoutSpacer.__proto__ || Object.getPrototypeOf(MdlLayoutSpacer)).apply(this, arguments));
    }

    _createClass(MdlLayoutSpacer, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlLayoutSpacer.prototype.__proto__ || Object.getPrototypeOf(MdlLayoutSpacer.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-layout-spacer");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)('div', { 'class': this.classList.join(" ") });
        }
    }]);

    return MdlLayoutSpacer;
}(_mdlBase.MdlBase);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlNavigationLink = exports.MdlNavigation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlNavigation = exports.MdlNavigation = function (_MdlBase) {
    _inherits(MdlNavigation, _MdlBase);

    function MdlNavigation() {
        _classCallCheck(this, MdlNavigation);

        return _possibleConstructorReturn(this, (MdlNavigation.__proto__ || Object.getPrototypeOf(MdlNavigation)).apply(this, arguments));
    }

    _createClass(MdlNavigation, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlNavigation.prototype.__proto__ || Object.getPrototypeOf(MdlNavigation.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-navigation");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'nav',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlNavigation;
}(_mdlBase.MdlBase);

var MdlNavigationLink = exports.MdlNavigationLink = function (_MdlBase2) {
    _inherits(MdlNavigationLink, _MdlBase2);

    function MdlNavigationLink() {
        _classCallCheck(this, MdlNavigationLink);

        return _possibleConstructorReturn(this, (MdlNavigationLink.__proto__ || Object.getPrototypeOf(MdlNavigationLink)).apply(this, arguments));
    }

    _createClass(MdlNavigationLink, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlNavigationLink.prototype.__proto__ || Object.getPrototypeOf(MdlNavigationLink.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-navigation__link");
        }
    }, {
        key: 'closeMenu',
        value: function closeMenu() {
            // let layout = document.querySelector('.mdl-layout');
            // //nur, wenn opened
            // layout.MaterialLayout.toggleDrawer();
            var drawerIsVisible = document.querySelector('.mdl-layout__drawer.is-visible');
            if (drawerIsVisible) {
                var layout = document.querySelector('.mdl-layout');
                layout.MaterialLayout.toggleDrawer();
            }
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            var _this3 = this;

            return (0, _mithril2.default)(
                'a',
                {
                    'class': this.classList.join(" "),
                    onclick: vnode.attrs.onclick ? function (e) {
                        e.stopPropagation();_this3.closeMenu();vnode.attrs.onclick();
                    } : function () {
                        return _this3.closeMenu();
                    },
                    href: vnode.attrs.href },
                vnode.attrs.text ? vnode.attrs.text : vnode.children
            );
        }
    }]);

    return MdlNavigationLink;
}(_mdlBase.MdlBase);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlSpinner = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlSpinner = exports.MdlSpinner = function (_MdlBase) {
    _inherits(MdlSpinner, _MdlBase);

    function MdlSpinner() {
        _classCallCheck(this, MdlSpinner);

        return _possibleConstructorReturn(this, (MdlSpinner.__proto__ || Object.getPrototypeOf(MdlSpinner)).apply(this, arguments));
    }

    _createClass(MdlSpinner, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlSpinner.prototype.__proto__ || Object.getPrototypeOf(MdlSpinner.prototype), 'oninit', this).call(this, vnode);
        }
    }, {
        key: 'onupdate',
        value: function onupdate(vnode) {
            // componentHandler.downgradeElements(vnode.dom);//downgrade to reregister!
            // componentHandler.upgradeElement(vnode.dom);
            //vnode.dom.style.display = 'none'; 
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            this.classList = [];
            this.classList.push("mdl-spinner", "mdl-js-spinner");
            vnode.attrs.singlecolor ? this.classList.push("mdl-spinner--single-color") : null;
            if (vnode.attrs.active && vnode.attrs.active != "false") {
                this.classList.push("is-active");

                //componentHandler.upgradeAllRegistered();
            }

            return (0, _mithril2.default)('div', {
                'class': this.classList.join(" ")
            });
        }
    }]);

    return MdlSpinner;
}(_mdlBase.MdlBase);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(28);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(27);

var _mdlBadge = __webpack_require__(10);

var _mdlButton = __webpack_require__(3);

var _mdlChip = __webpack_require__(12);

var _mdlIcon = __webpack_require__(2);

var _mdlToggle = __webpack_require__(21);

var _mdlGrid = __webpack_require__(14);

var _mdlLayout = __webpack_require__(4);

var _mdlList = __webpack_require__(15);

var _mdlNavigation = __webpack_require__(5);

var _mdlDialog = __webpack_require__(13);

var _mdlSlider = __webpack_require__(16);

var _mdlSpinner = __webpack_require__(6);

var _mdlCard = __webpack_require__(11);

var _mdlTab = __webpack_require__(18);

var _mdlTextfield = __webpack_require__(20);

var _mdlSnackbar = __webpack_require__(17);

var _mdlTable = __webpack_require__(19);

var _mdlToolbar = __webpack_require__(22);

//custom tweaks

module.exports.Mdl = {
    Badge: _mdlBadge.MdlBadge,

    Button: _mdlButton.MdlButton,

    Card: _mdlCard.MdlCard,
    CardActions: _mdlCard.MdlCardActions,
    CardSupportingText: _mdlCard.MdlCardSupportingText,
    CardTitle: _mdlCard.MdlCardTitle,
    CardTitleText: _mdlCard.MdlCardTitleText,
    CardSubtitleText: _mdlCard.MdlCardSubtitleText,
    CardMenu: _mdlCard.MdlCardMenu,

    Chip: _mdlChip.MdlChip,

    Dialog: _mdlDialog.MdlDialog,
    DialogService: _mdlDialog.MdlDialogService,

    Icon: _mdlIcon.MdlIcon,

    Layout: _mdlLayout.MdlLayout,
    LayoutContent: _mdlLayout.MdlLayoutContent,
    LayoutDrawer: _mdlLayout.MdlLayoutDrawer,
    LayoutHeader: _mdlLayout.MdlLayoutHeader,
    LayoutTitle: _mdlLayout.MdlLayoutTitle,
    LayoutSpacer: _mdlLayout.MdlLayoutSpacer,

    Grid: _mdlGrid.MdlGrid,
    Cell: _mdlGrid.MdlCell,

    List: _mdlList.MdlList,
    ListItem: _mdlList.MdlListItem,
    ListItemPrimaryContent: _mdlList.MdlListItemPrimaryContent,
    ListItemSecondaryAction: _mdlList.MdlListItemSecondaryAction,
    ListItemSubTitle: _mdlList.MdlListItemSubTitle,
    ListSubHeader: _mdlList.MdlListSubHeader,
    ListItemText: _mdlList.MdlListItemText,

    Navigation: _mdlNavigation.MdlNavigation,
    NavigationLink: _mdlNavigation.MdlNavigationLink,

    Slider: _mdlSlider.MdlSlider,

    SnackBar: _mdlSnackbar.MdlSnackBar,
    SnackBarService: _mdlSnackbar.MdlSnackBarService,

    Spinner: _mdlSpinner.MdlSpinner,

    Tab: _mdlTab.MdlTab,
    TabBar: _mdlTab.MdlTabBar,
    TabPanel: _mdlTab.MdlTabPanel,
    Tabs: _mdlTab.MdlTabs,

    Table: _mdlTable.MdlTable,

    TextField: _mdlTextfield.MdlTextField,
    TextFieldInput: _mdlTextfield.MdlTextFieldInput,
    TextFieldLabel: _mdlTextfield.MdlTextFieldLabel,
    TextFieldError: _mdlTextfield.MdlTextFieldError,

    Toggle: _mdlToggle.MdlToggle,

    Toolbar: _mdlToolbar.MdlToolbar
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlBadge = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlBadge = exports.MdlBadge = function (_MdlBase) {
    _inherits(MdlBadge, _MdlBase);

    function MdlBadge() {
        _classCallCheck(this, MdlBadge);

        return _possibleConstructorReturn(this, (MdlBadge.__proto__ || Object.getPrototypeOf(MdlBadge)).apply(this, arguments));
    }

    _createClass(MdlBadge, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlBadge.prototype.__proto__ || Object.getPrototypeOf(MdlBadge.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-badge");
            vnode.attrs.icon ? this.classList.push("material-icons") : null;
            vnode.attrs.overlap ? this.classList.push("mdl-badge--overlap") : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            var attributes = {};
            vnode.attrs.onclick ? attributes.onclick = function (e) {
                return vnode.attrs.onclick(e);
            } : null;

            return (0, _mithril2.default)(
                'span',
                _extends({
                    'class': this.classList.join(" "),
                    'data-badge': vnode.attrs.value
                }, attributes),
                vnode.attrs.icon ? vnode.attrs.icon : vnode.children
            );
        }
    }]);

    return MdlBadge;
}(_mdlBase.MdlBase);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlCardMenu = exports.MdlCardActions = exports.MdlCardSupportingText = exports.MdlCardSubtitleText = exports.MdlCardTitleText = exports.MdlCardTitle = exports.MdlCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlCard = exports.MdlCard = function (_MdlBase) {
    _inherits(MdlCard, _MdlBase);

    function MdlCard() {
        _classCallCheck(this, MdlCard);

        return _possibleConstructorReturn(this, (MdlCard.__proto__ || Object.getPrototypeOf(MdlCard)).apply(this, arguments));
    }

    _createClass(MdlCard, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlCard.prototype.__proto__ || Object.getPrototypeOf(MdlCard.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-card", "mdl-shadow--2dp");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': this.classList.join(" ") },
                vnode.attrs.title ? (0, _mithril2.default)(MdlCardTitle, { title: vnode.attrs.title, subtitle: vnode.attrs.subtitle }) : null,
                vnode.attrs.text ? (0, _mithril2.default)(MdlCardSupportingText, { text: vnode.attrs.text }) : null,
                vnode.attrs.actions ? (0, _mithril2.default)(
                    MdlCardActions,
                    null,
                    vnode.attrs.actions
                ) : null,
                vnode.attrs.menu ? (0, _mithril2.default)(
                    MdlCardMenu,
                    null,
                    vnode.attrs.menu
                ) : null,
                vnode.children
            );
        }
    }]);

    return MdlCard;
}(_mdlBase.MdlBase);

var MdlCardTitle = exports.MdlCardTitle = function () {
    function MdlCardTitle() {
        _classCallCheck(this, MdlCardTitle);
    }

    _createClass(MdlCardTitle, [{
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': 'mdl-card__title mdl-card--expand' },
                vnode.attrs.title ? (0, _mithril2.default)(MdlCardTitleText, { title: vnode.attrs.title }) : null,
                vnode.attrs.subtitle ? (0, _mithril2.default)(MdlCardSubtitleText, { subtitle: vnode.attrs.subtitle }) : null
            );
        }
    }]);

    return MdlCardTitle;
}();

var MdlCardTitleText = exports.MdlCardTitleText = function () {
    function MdlCardTitleText() {
        _classCallCheck(this, MdlCardTitleText);
    }

    _createClass(MdlCardTitleText, [{
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'h2',
                { 'class': 'mdl-card__title-text' },
                vnode.attrs.title
            );
        }
    }]);

    return MdlCardTitleText;
}();

var MdlCardSubtitleText = exports.MdlCardSubtitleText = function () {
    function MdlCardSubtitleText() {
        _classCallCheck(this, MdlCardSubtitleText);
    }

    _createClass(MdlCardSubtitleText, [{
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': 'mdl-card__subtitle-text' },
                vnode.attrs.subtitle
            );
        }
    }]);

    return MdlCardSubtitleText;
}();

var MdlCardSupportingText = exports.MdlCardSupportingText = function () {
    function MdlCardSupportingText() {
        _classCallCheck(this, MdlCardSupportingText);
    }

    _createClass(MdlCardSupportingText, [{
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                {
                    'class': 'mdl-card__supporting-text'
                },
                (0, _mithril2.default)(
                    'div',
                    { style: 'padding: 16px;' },
                    vnode.attrs.text ? vnode.attrs.text : vnode.children
                )
            );
        }
    }]);

    return MdlCardSupportingText;
}();

var MdlCardActions = exports.MdlCardActions = function () {
    function MdlCardActions() {
        _classCallCheck(this, MdlCardActions);
    }

    _createClass(MdlCardActions, [{
        key: 'oninit',
        // mdl-card--border
        value: function oninit(vnode) {
            this.classList = ["mdl-card__actions"];
            vnode.attrs.border ? this.classList.push("mdl-card--border") : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                {
                    'class': this.classList.join(" "),
                    style: 'overflow-x: auto;'
                },
                vnode.children
            );
        }
    }]);

    return MdlCardActions;
}();

var MdlCardMenu = exports.MdlCardMenu = function () {
    function MdlCardMenu() {
        _classCallCheck(this, MdlCardMenu);
    }

    _createClass(MdlCardMenu, [{
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': 'mdl-card__menu' },
                vnode.children
            );
        }
    }]);

    return MdlCardMenu;
}();

//mdl-card--border

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlChip = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlIcon = __webpack_require__(2);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlChip = exports.MdlChip = function (_MdlBase) {
    _inherits(MdlChip, _MdlBase);

    function MdlChip() {
        _classCallCheck(this, MdlChip);

        return _possibleConstructorReturn(this, (MdlChip.__proto__ || Object.getPrototypeOf(MdlChip)).apply(this, arguments));
    }

    _createClass(MdlChip, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlChip.prototype.__proto__ || Object.getPrototypeOf(MdlChip.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-chip");

            this.contactClassList = ["mdl-chip__contact"];

            vnode.attrs.contact ? this.classList.push("mdl-chip--contact") : null;
            vnode.attrs.contact && vnode.attrs.contactColor ? this.contactClassList.push('mdl-color--' + vnode.attrs.contactColor) : null;
            vnode.attrs.contact && vnode.attrs.contactColorText ? this.contactClassList.push('mdl-color-text--' + vnode.attrs.contactColorText) : null;

            vnode.attrs.deletable ? this.classList.push("mdl-chip--deletable") : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            var deleteAttributes = {};
            vnode.attrs.onclick ? deleteAttributes.onclick = function (e) {
                return vnode.attrs.onclick(e);
            } : null;

            return (0, _mithril2.default)(
                'span',
                { 'class': this.classList.join(" ") },
                vnode.attrs.contact ? (0, _mithril2.default)(
                    'span',
                    { 'class': this.contactClassList.join(" ") },
                    vnode.attrs.contact
                ) : null,
                (0, _mithril2.default)(
                    'span',
                    { 'class': 'mdl-chip__text' },
                    vnode.attrs.text ? vnode.attrs.text : vnode.children
                ),
                vnode.attrs.deletable ? (0, _mithril2.default)(
                    'button',
                    _extends({
                        type: 'button',
                        'class': 'mdl-chip__action'
                    }, deleteAttributes),
                    (0, _mithril2.default)(_mdlIcon.MdlIcon, { icon: vnode.attrs.deleteIcon ? vnode.attrs.deleteIcon : "cancel" })
                ) : null
            );
        }
    }]);

    return MdlChip;
}(_mdlBase.MdlBase);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlDialogService = exports.MdlDialog = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

var _mdlSpinner = __webpack_require__(6);

__webpack_require__(26);

var _dialogPolyfill = __webpack_require__(25);

var dialogPolyfill = _interopRequireWildcard(_dialogPolyfill);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlDialog = exports.MdlDialog = function (_MdlBase) {
    _inherits(MdlDialog, _MdlBase);

    function MdlDialog() {
        _classCallCheck(this, MdlDialog);

        return _possibleConstructorReturn(this, (MdlDialog.__proto__ || Object.getPrototypeOf(MdlDialog)).apply(this, arguments));
    }

    _createClass(MdlDialog, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlDialog.prototype.__proto__ || Object.getPrototypeOf(MdlDialog.prototype), 'oninit', this).call(this, vnode);
            this.vnode = vnode;
        }
    }, {
        key: 'onok',
        value: function onok() {
            this.close();
        }
    }, {
        key: 'close',
        value: function close() {
            this.vnode.dom.close();
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'dialog',
                { 'class': 'mdl-dialog' },
                (0, _mithril2.default)('h4', { 'class': 'mdl-dialog__title', style: 'padding:10px; text-align:center;' }),
                (0, _mithril2.default)(
                    'div',
                    { 'class': 'mdl-dialog__content', style: 'text-align:center;', hidden: true },
                    (0, _mithril2.default)('div', { 'class': 'mdl-spinner mdl-spinner--single-color mdl-js-spinner is-active' })
                ),
                (0, _mithril2.default)(
                    'div',
                    { 'class': 'mdl-dialog__actions', hidden: true },
                    (0, _mithril2.default)(
                        'button',
                        { type: 'button', 'class': 'mdl-button ok', id: 'mdlDialogOkButton' },
                        vnode.attrs.okText ? vnode.attrs.okText : "ok"
                    ),
                    (0, _mithril2.default)(
                        'button',
                        { type: 'button', 'class': 'mdl-button close', id: 'mdlDialogCancelButton' },
                        vnode.attrs.cancelText ? vnode.attrs.cancelText : "close"
                    )
                )
            );
        }
    }]);

    return MdlDialog;
}(_mdlBase.MdlBase);

var MdlDialogService = exports.MdlDialogService = function () {
    function MdlDialogService() {
        _classCallCheck(this, MdlDialogService);
    }

    _createClass(MdlDialogService, [{
        key: 'showConfirm',
        value: function showConfirm(title, description, showOkCancel, onOk, onCancel) {
            var _this2 = this;

            //console.log("mdlDialogService.show");
            var dialog = document.querySelector('dialog');
            dialogPolyfill.registerDialog(dialog); //only if not chrome?

            var dialogTitle = dialog.querySelector(".mdl-dialog__title");
            var dialogContent = dialog.querySelector(".mdl-dialog__content");
            var dialogActions = dialog.querySelector(".mdl-dialog__actions");

            dialogTitle.innerHTML = title;
            dialogContent.setAttribute("hidden", "hidden");
            dialogActions.setAttribute("hidden", "hidden");

            if (description) {
                dialogContent.removeAttribute("hidden");
                _mithril2.default.render(dialogContent, (0, _mithril2.default)(
                    'span',
                    null,
                    description
                ));
            }

            if (showOkCancel) {
                dialog.querySelector(".mdl-dialog__actions").removeAttribute("hidden");

                dialog.querySelector('.ok').addEventListener('click', function () {
                    _this2.hide();
                    onOk ? onOk() : null;
                });

                dialog.querySelector('.close').addEventListener('click', function () {
                    _this2.hide();
                    onCancel ? onCancel() : null;
                });
            }

            dialog.showModal();
        }
    }, {
        key: 'showLoader',
        value: function showLoader(title) {
            //console.log("mdlDialogService.show");
            var dialog = document.querySelector('dialog');
            dialogPolyfill.registerDialog(dialog);

            var dialogTitle = dialog.querySelector(".mdl-dialog__title");
            var dialogContent = dialog.querySelector(".mdl-dialog__content");
            var dialogActions = dialog.querySelector(".mdl-dialog__actions");

            dialogTitle.innerHTML = title;
            dialogContent.setAttribute("hidden", "hidden");
            dialogActions.setAttribute("hidden", "hidden");

            dialogContent.removeAttribute("hidden");
            _mithril2.default.render(dialogContent, (0, _mithril2.default)(_mdlSpinner.MdlSpinner, { active: true, singlecolor: true }));

            componentHandler.upgradeElement(document.querySelector(".mdl-js-spinner")); //hack for spinner showing correctly 
            dialog.showModal();
        }
    }, {
        key: 'hide',
        value: function hide() {
            var dialog = document.querySelector('dialog');

            if (dialog.hasAttribute("open")) {
                dialog.close();

                var oldOkBtn = dialog.querySelector("#mdlDialogOkButton");
                var newOkBtn = oldOkBtn.cloneNode(true);
                oldOkBtn.parentNode.replaceChild(newOkBtn, oldOkBtn);

                var oldCancelBtn = dialog.querySelector("#mdlDialogCancelButton");
                var newCancelBtn = oldCancelBtn.cloneNode(true);
                oldCancelBtn.parentNode.replaceChild(newCancelBtn, oldCancelBtn);
            }
        }
    }]);

    return MdlDialogService;
}();

;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlCell = exports.MdlGrid = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlGrid = exports.MdlGrid = function (_MdlBase) {
    _inherits(MdlGrid, _MdlBase);

    function MdlGrid() {
        _classCallCheck(this, MdlGrid);

        return _possibleConstructorReturn(this, (MdlGrid.__proto__ || Object.getPrototypeOf(MdlGrid)).apply(this, arguments));
    }

    _createClass(MdlGrid, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlGrid.prototype.__proto__ || Object.getPrototypeOf(MdlGrid.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-grid");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlGrid;
}(_mdlBase.MdlBase);

var MdlCell = exports.MdlCell = function (_MdlBase2) {
    _inherits(MdlCell, _MdlBase2);

    function MdlCell() {
        _classCallCheck(this, MdlCell);

        return _possibleConstructorReturn(this, (MdlCell.__proto__ || Object.getPrototypeOf(MdlCell)).apply(this, arguments));
    }

    _createClass(MdlCell, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlCell.prototype.__proto__ || Object.getPrototypeOf(MdlCell.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-cell");

            vnode.attrs.col ? this.classList.push('mdl-cell--' + vnode.attrs.col + '-col') : null;
            vnode.attrs.colDesktop ? this.classList.push('mdl-cell--' + vnode.attrs.colDesktop + '-col-desktop') : null;
            vnode.attrs.colTablet ? this.classList.push('mdl-cell--' + vnode.attrs.colTablet + '-col-tablet') : null;
            vnode.attrs.colPhone ? this.classList.push('mdl-cell--' + vnode.attrs.colPhone + '-col-phone') : null;

            vnode.attrs.offset ? this.classList.push('mdl-cell--' + vnode.attrs.offset + '-offset') : null;
            vnode.attrs.offsetDesktop ? this.classList.push('mdl-cell--' + vnode.attrs.offsetDesktop + '-offset-desktop') : null;
            vnode.attrs.offsetTablet ? this.classList.push('mdl-cell--' + vnode.attrs.offsetTablet + '-offset-tablet') : null;
            vnode.attrs.offsetPhone ? this.classList.push('mdl-cell--' + vnode.attrs.offsetPhone + '-offset-phone') : null;

            vnode.attrs.order ? this.classList.push('mdl-cell--order-' + vnode.attrs.order) : null;
            vnode.attrs.orderDesktop ? this.classList.push('mdl-cell--order-' + vnode.attrs.orderDesktop + '-desktop') : null;
            vnode.attrs.orderTablet ? this.classList.push('mdl-cell--order-' + vnode.attrs.orderTablet + '-tablet') : null;
            vnode.attrs.orderPhone ? this.classList.push('mdl-cell--order-' + vnode.attrs.orderPhone + '-phone') : null;

            vnode.attrs.hideDesktop ? this.classList.push('mdl-cell--hide-desktop') : null;
            vnode.attrs.hideTablet ? this.classList.push('mdl-cell--hide-tablet') : null;
            vnode.attrs.hidePhone ? this.classList.push('mdl-cell--hide-phone') : null;

            vnode.attrs.stretch ? this.classList.push('mdl-cell--stretch') : null;
            vnode.attrs.top ? this.classList.push('mdl-cell--top') : null;
            vnode.attrs.middle ? this.classList.push('mdl-cell--middle') : null;
            vnode.attrs.bottom ? this.classList.push('mdl-cell--bottom') : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlCell;
}(_mdlBase.MdlBase);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlListItemText = exports.MdlListSubHeader = exports.MdlListItemSubTitle = exports.MdlListItemSecondaryAction = exports.MdlListItemPrimaryContent = exports.MdlListItem = exports.MdlList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

var _mdlIcon = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlList = exports.MdlList = function (_MdlBase) {
    _inherits(MdlList, _MdlBase);

    function MdlList() {
        _classCallCheck(this, MdlList);

        return _possibleConstructorReturn(this, (MdlList.__proto__ || Object.getPrototypeOf(MdlList)).apply(this, arguments));
    }

    _createClass(MdlList, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlList.prototype.__proto__ || Object.getPrototypeOf(MdlList.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-list");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'ul',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlList;
}(_mdlBase.MdlBase);

var MdlListItem = exports.MdlListItem = function (_MdlBase2) {
    _inherits(MdlListItem, _MdlBase2);

    function MdlListItem() {
        _classCallCheck(this, MdlListItem);

        return _possibleConstructorReturn(this, (MdlListItem.__proto__ || Object.getPrototypeOf(MdlListItem)).apply(this, arguments));
    }

    _createClass(MdlListItem, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlListItem.prototype.__proto__ || Object.getPrototypeOf(MdlListItem.prototype), 'oninit', this).call(this, vnode);

            this.classList = [];
            this.classList.push("mdl-list__item");
            vnode.attrs.border ? this.classList.push("mdl-list__item-border") : null;
            vnode.attrs.twoLine ? this.classList.push("mdl-list__item--two-line") : null;
            vnode.attrs.threeLine ? this.classList.push("mdl-list__item--three-line") : null;
            vnode.attrs.dropDown ? this.classList.push("mdl-list__item--drop-down", "in") : null;

            this.isDropDownCollapsed = vnode.attrs.dropDown ? true : false;
        }
    }, {
        key: 'onClick',
        value: function onClick(e, vnode) {
            e.stopPropagation();

            if (this.isDropDownCollapsed != undefined) {
                this.isDropDownCollapsed = !this.isDropDownCollapsed;

                if (this.isDropDownCollapsed) this.classList.push("in");else this.classList.splice(this.classList.indexOf("in"), 2);
            }

            if (vnode.attrs.onclick) vnode.attrs.onclick(e);
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            var _this3 = this;

            return (0, _mithril2.default)(
                'li',
                {
                    'class': this.classList.join(" ") + (' mdl-color-text--' + vnode.attrs.color),
                    onclick: function onclick(e) {
                        _this3.onClick(e, vnode);
                    }
                },
                vnode.children,
                vnode.attrs.dropDown ? this.isDropDownCollapsed ? (0, _mithril2.default)(_mdlIcon.MdlIcon, { icon: 'keyboard_arrow_down', 'class': 'toggle' }) : (0, _mithril2.default)(_mdlIcon.MdlIcon, { icon: 'keyboard_arrow_up', 'class': 'toggle' }) : null
            );
        }
    }]);

    return MdlListItem;
}(_mdlBase.MdlBase);

var MdlListItemPrimaryContent = exports.MdlListItemPrimaryContent = function (_MdlBase3) {
    _inherits(MdlListItemPrimaryContent, _MdlBase3);

    function MdlListItemPrimaryContent() {
        _classCallCheck(this, MdlListItemPrimaryContent);

        return _possibleConstructorReturn(this, (MdlListItemPrimaryContent.__proto__ || Object.getPrototypeOf(MdlListItemPrimaryContent)).apply(this, arguments));
    }

    _createClass(MdlListItemPrimaryContent, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlListItemPrimaryContent.prototype.__proto__ || Object.getPrototypeOf(MdlListItemPrimaryContent.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-list__item-primary-content");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'span',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlListItemPrimaryContent;
}(_mdlBase.MdlBase);

var MdlListItemSecondaryAction = exports.MdlListItemSecondaryAction = function (_MdlBase4) {
    _inherits(MdlListItemSecondaryAction, _MdlBase4);

    function MdlListItemSecondaryAction() {
        _classCallCheck(this, MdlListItemSecondaryAction);

        return _possibleConstructorReturn(this, (MdlListItemSecondaryAction.__proto__ || Object.getPrototypeOf(MdlListItemSecondaryAction)).apply(this, arguments));
    }

    _createClass(MdlListItemSecondaryAction, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlListItemSecondaryAction.prototype.__proto__ || Object.getPrototypeOf(MdlListItemSecondaryAction.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-list__item-secondary-action");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'a',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlListItemSecondaryAction;
}(_mdlBase.MdlBase);

var MdlListItemSubTitle = exports.MdlListItemSubTitle = function (_MdlBase5) {
    _inherits(MdlListItemSubTitle, _MdlBase5);

    function MdlListItemSubTitle() {
        _classCallCheck(this, MdlListItemSubTitle);

        return _possibleConstructorReturn(this, (MdlListItemSubTitle.__proto__ || Object.getPrototypeOf(MdlListItemSubTitle)).apply(this, arguments));
    }

    _createClass(MdlListItemSubTitle, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlListItemSubTitle.prototype.__proto__ || Object.getPrototypeOf(MdlListItemSubTitle.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-list__item-sub-title");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'span',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlListItemSubTitle;
}(_mdlBase.MdlBase);

//custom - innerhalb von mdl.list nutzen!


var MdlListSubHeader = exports.MdlListSubHeader = function (_MdlBase6) {
    _inherits(MdlListSubHeader, _MdlBase6);

    function MdlListSubHeader() {
        _classCallCheck(this, MdlListSubHeader);

        return _possibleConstructorReturn(this, (MdlListSubHeader.__proto__ || Object.getPrototypeOf(MdlListSubHeader)).apply(this, arguments));
    }

    _createClass(MdlListSubHeader, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlListSubHeader.prototype.__proto__ || Object.getPrototypeOf(MdlListSubHeader.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-list__subheader");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'li',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlListSubHeader;
}(_mdlBase.MdlBase);

var MdlListItemText = exports.MdlListItemText = function (_MdlBase7) {
    _inherits(MdlListItemText, _MdlBase7);

    function MdlListItemText() {
        _classCallCheck(this, MdlListItemText);

        return _possibleConstructorReturn(this, (MdlListItemText.__proto__ || Object.getPrototypeOf(MdlListItemText)).apply(this, arguments));
    }

    _createClass(MdlListItemText, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlListItemText.prototype.__proto__ || Object.getPrototypeOf(MdlListItemText.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-list__item-text-body");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'span',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlListItemText;
}(_mdlBase.MdlBase);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlSlider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlSlider = exports.MdlSlider = function (_MdlBase) {
    _inherits(MdlSlider, _MdlBase);

    function MdlSlider() {
        _classCallCheck(this, MdlSlider);

        return _possibleConstructorReturn(this, (MdlSlider.__proto__ || Object.getPrototypeOf(MdlSlider)).apply(this, arguments));
    }

    _createClass(MdlSlider, [{
        key: 'oninit',
        value: function oninit(vnode) {
            var _this2 = this;

            _get(MdlSlider.prototype.__proto__ || Object.getPrototypeOf(MdlSlider.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("custom-slider");

            this.attributes = {};
            // vnode.attrs.value ? this.attributes.value = vnode.attrs.value : this.attributes.value = 0;//should be initial
            vnode.attrs.min ? this.attributes.min = vnode.attrs.min : this.attributes.min = 0;
            vnode.attrs.max ? this.attributes.max = vnode.attrs.max : this.attributes.max = 100;
            vnode.attrs.step ? this.attributes.step = vnode.attrs.step : this.attributes.step = 1;

            this.attributes.oninput = function (e) {
                _this2.currentValue = e.target.value;
                if (vnode.attrs.oninput) vnode.attrs.oninput(e);
                _this2.setStyle(vnode.dom, _this2.attributes.min, _this2.attributes.max, e.target.value);
            };

            this.attributes.onchange = function (e) {
                _this2.currentValue = e.target.value;
                if (vnode.attrs.onchange) vnode.attrs.onchange(e);
                _this2.setStyle(vnode.dom, _this2.attributes.min, _this2.attributes.max, e.target.value);
            };

            this.currentValue = vnode.attrs.value ? vnode.attrs.value : 0;
        }
    }, {
        key: 'oncreate',
        value: function oncreate(vnode) {
            this.setStyle(vnode.dom, this.attributes.min, this.attributes.max);
        }
    }, {
        key: 'setStyle',
        value: function setStyle(element, min, max) {
            if (min && max) element.style.backgroundSize = (this.currentValue - min) * 100 / (max - min) + '% 100%';else element.style.backgroundSize = (this.currentValue ? this.currentValue : 0) + '% 100%';
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)('input', _extends({ 'class': this.classList.join(" "), type: 'range' }, this.attributes, { value: this.currentValue }));
        }
    }]);

    return MdlSlider;
}(_mdlBase.MdlBase);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlSnackBarService = exports.MdlSnackBar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlSnackBar = exports.MdlSnackBar = function (_MdlBase) {
    _inherits(MdlSnackBar, _MdlBase);

    function MdlSnackBar() {
        _classCallCheck(this, MdlSnackBar);

        return _possibleConstructorReturn(this, (MdlSnackBar.__proto__ || Object.getPrototypeOf(MdlSnackBar)).apply(this, arguments));
    }

    _createClass(MdlSnackBar, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlSnackBar.prototype.__proto__ || Object.getPrototypeOf(MdlSnackBar.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-js-snackbar", "mdl-snackbar");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': this.classList.join(" ") },
                (0, _mithril2.default)('div', { 'class': 'mdl-snackbar__text' }),
                (0, _mithril2.default)('button', { 'class': 'mdl-snackbar__action', type: 'button' })
            );
        }
    }]);

    return MdlSnackBar;
}(_mdlBase.MdlBase);

var MdlSnackBarService = exports.MdlSnackBarService = function () {
    function MdlSnackBarService() {
        _classCallCheck(this, MdlSnackBarService);
    }

    _createClass(MdlSnackBarService, [{
        key: 'show',
        value: function show(message, timeout, actionText, _actionHandler) {
            var snackBarContainer = document.querySelector('.mdl-snackbar');
            var data = {
                message: message ? message : "info",
                timeout: timeout ? timeout : 2000,
                actionHandler: function actionHandler() {
                    snackBarContainer.MaterialSnackbar.hideSnackbar ? snackBarContainer.MaterialSnackbar.hideSnackbar() : null;
                    _actionHandler ? _actionHandler() : null;
                },
                actionText: actionText ? actionText : 'ok'
            };

            snackBarContainer.MaterialSnackbar.showSnackbar(data);
        }
    }]);

    return MdlSnackBarService;
}();

;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlTabPanel = exports.MdlTab = exports.MdlTabBar = exports.MdlTabs = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlTabs = exports.MdlTabs = function (_MdlBase) {
    _inherits(MdlTabs, _MdlBase);

    function MdlTabs() {
        _classCallCheck(this, MdlTabs);

        return _possibleConstructorReturn(this, (MdlTabs.__proto__ || Object.getPrototypeOf(MdlTabs)).apply(this, arguments));
    }

    _createClass(MdlTabs, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlTabs.prototype.__proto__ || Object.getPrototypeOf(MdlTabs.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-tabs", "mdl-js-tabs", "mdl-js-ripple-effect");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlTabs;
}(_mdlBase.MdlBase);

var MdlTabBar = exports.MdlTabBar = function (_MdlBase2) {
    _inherits(MdlTabBar, _MdlBase2);

    function MdlTabBar() {
        _classCallCheck(this, MdlTabBar);

        return _possibleConstructorReturn(this, (MdlTabBar.__proto__ || Object.getPrototypeOf(MdlTabBar)).apply(this, arguments));
    }

    _createClass(MdlTabBar, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlTabBar.prototype.__proto__ || Object.getPrototypeOf(MdlTabBar.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-tabs__tab-bar");
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlTabBar;
}(_mdlBase.MdlBase);

var MdlTab = exports.MdlTab = function (_MdlBase3) {
    _inherits(MdlTab, _MdlBase3);

    function MdlTab() {
        _classCallCheck(this, MdlTab);

        return _possibleConstructorReturn(this, (MdlTab.__proto__ || Object.getPrototypeOf(MdlTab)).apply(this, arguments));
    }

    _createClass(MdlTab, [{
        key: 'oninit',
        value: function oninit(vnode) {
            this.classList.push("mdl-tabs__tab");
            vnode.attrs.active ? this.classList.push("is-active") : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'a',
                {
                    'class': this.classList.join(" "),
                    href: "#" + vnode.attrs.target,
                    onclick: vnode.attrs.onclick ? function (e) {
                        vnode.attrs.onclick();
                    } : null
                },
                vnode.children
            );
        }
    }]);

    return MdlTab;
}(_mdlBase.MdlBase);

var MdlTabPanel = exports.MdlTabPanel = function (_MdlBase4) {
    _inherits(MdlTabPanel, _MdlBase4);

    function MdlTabPanel() {
        _classCallCheck(this, MdlTabPanel);

        return _possibleConstructorReturn(this, (MdlTabPanel.__proto__ || Object.getPrototypeOf(MdlTabPanel)).apply(this, arguments));
    }

    _createClass(MdlTabPanel, [{
        key: 'oninit',
        value: function oninit(vnode) {
            this.classList = ["mdl-tabs__panel"];
            vnode.attrs.active ? this.classList.push("is-active") : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                {
                    'class': this.classList.join(" "), id: vnode.attrs.id,
                    style: 'overflow-x: auto;'
                },
                vnode.children
            );
        }
    }]);

    return MdlTabPanel;
}(_mdlBase.MdlBase);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlTable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlTable = exports.MdlTable = function (_MdlBase) {
    _inherits(MdlTable, _MdlBase);

    function MdlTable() {
        _classCallCheck(this, MdlTable);

        return _possibleConstructorReturn(this, (MdlTable.__proto__ || Object.getPrototypeOf(MdlTable)).apply(this, arguments));
    }

    _createClass(MdlTable, [{
        key: 'oninit',
        value: function oninit(vnode) {
            this.classList.push("mdl-data-table", "mdl-js-data-table", "mdl-shadow--2dp");
            vnode.attrs.selectable ? this.classList.push("mdl-data-table--selectable") : null;
            vnode.attrs.sortasc ? this.classList.push("mdl-data-table__header--sorted-ascending") : null;
            vnode.attrs.sortdesc ? this.classList.push("mdl-data-table__header--sorted-descending") : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'table',
                {
                    'class': this.classList.join(" ")
                },
                vnode.children
            );
        }
    }]);

    return MdlTable;
}(_mdlBase.MdlBase);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlTextFieldError = exports.MdlTextFieldLabel = exports.MdlTextFieldInput = exports.MdlTextField = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlTextField = exports.MdlTextField = function (_MdlBase) {
    _inherits(MdlTextField, _MdlBase);

    function MdlTextField() {
        _classCallCheck(this, MdlTextField);

        var _this = _possibleConstructorReturn(this, (MdlTextField.__proto__ || Object.getPrototypeOf(MdlTextField)).call(this));

        _this.vnode;
        return _this;
    }

    _createClass(MdlTextField, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlTextField.prototype.__proto__ || Object.getPrototypeOf(MdlTextField.prototype), 'oninit', this).call(this, vnode);

            this.vnode = vnode;
            this.classList.push("mdl-textfield", "mdl-js-textfield");
            vnode.attrs.floatingLabel ? this.classList.push("mdl-textfield--floating-label") : null;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'div',
                { 'class': this.classList.join(" ") },
                vnode.children
            );
        }
    }]);

    return MdlTextField;
}(_mdlBase.MdlBase);

var MdlTextFieldInput = exports.MdlTextFieldInput = function (_MdlBase2) {
    _inherits(MdlTextFieldInput, _MdlBase2);

    function MdlTextFieldInput() {
        _classCallCheck(this, MdlTextFieldInput);

        var _this2 = _possibleConstructorReturn(this, (MdlTextFieldInput.__proto__ || Object.getPrototypeOf(MdlTextFieldInput)).call(this));

        _this2.dom;
        return _this2;
    }

    _createClass(MdlTextFieldInput, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlTextFieldInput.prototype.__proto__ || Object.getPrototypeOf(MdlTextFieldInput.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-textfield__input");
        }
    }, {
        key: 'oncreate',
        value: function oncreate(vnode) {
            var _this3 = this;

            this.dom = vnode.dom;
            //this.vnode = vnode;
            var oldValue = vnode.dom.value;
            //let oldValue = vnode.attrs.value;

            this.intervalCheck = setInterval(function () {
                var newVal = vnode.dom.value;
                //let newVal = vnode.attrs.value;

                if (oldValue != newVal) {
                    _this3.updateTextField();
                    window.clearInterval(_this3.intervalCheck); //clear interval
                    //https://stackoverflow.com/questions/2901108/how-do-i-clear-this-setinterval
                }
            }, 300); //300 ok?, evtl. mit timeout final entfernen?

            setTimeout(function () {
                if (_this3.intervalCheck) window.clearInterval(_this3.intervalCheck); //final clear after 10 sec
            }, 6000);
        }
    }, {
        key: 'onremove',
        value: function onremove() {
            window.clearInterval(this.intervalCheck);
        }
    }, {
        key: 'updateTextField',
        value: function updateTextField() {
            var textField = closest(this.dom, "mdl-textfield");
            if (textField) {
                componentHandler.downgradeElements(textField); //downgrade to reregister!
                componentHandler.upgradeElement(textField);
            }
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            var attributes = {};
            vnode.attrs.pattern ? attributes.pattern = vnode.attrs.pattern : null;
            vnode.attrs.placeholder ? attributes.placeholder = vnode.attrs.placeholder : null;
            vnode.attrs.name ? attributes.name = vnode.attrs.name : null;
            vnode.attrs.type ? attributes.type = vnode.attrs.type : attributes.type = "text";
            vnode.attrs.value != "" ? attributes.value = vnode.attrs.value : attributes.value = "";
            vnode.attrs.oninput ? attributes.oninput = function (e) {
                return vnode.attrs.oninput(e);
            } : null;
            vnode.attrs.autocomplete ? attributes.autocomplete = "on" : attributes.autocomplete = "off";

            return (0, _mithril2.default)('input', _extends({
                'class': this.classList.join(" ")
            }, attributes));
        }
    }]);

    return MdlTextFieldInput;
}(_mdlBase.MdlBase);

var MdlTextFieldLabel = exports.MdlTextFieldLabel = function (_MdlBase3) {
    _inherits(MdlTextFieldLabel, _MdlBase3);

    function MdlTextFieldLabel() {
        _classCallCheck(this, MdlTextFieldLabel);

        return _possibleConstructorReturn(this, (MdlTextFieldLabel.__proto__ || Object.getPrototypeOf(MdlTextFieldLabel)).apply(this, arguments));
    }

    _createClass(MdlTextFieldLabel, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlTextFieldLabel.prototype.__proto__ || Object.getPrototypeOf(MdlTextFieldLabel.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-textfield__label");
        }

        //for="username" noch integrieren?

    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'label',
                { 'class': this.classList.join(" ") },
                vnode.attrs.value ? vnode.attrs.value : vnode.children
            );
        }
    }]);

    return MdlTextFieldLabel;
}(_mdlBase.MdlBase);

var MdlTextFieldError = exports.MdlTextFieldError = function (_MdlBase4) {
    _inherits(MdlTextFieldError, _MdlBase4);

    function MdlTextFieldError() {
        _classCallCheck(this, MdlTextFieldError);

        return _possibleConstructorReturn(this, (MdlTextFieldError.__proto__ || Object.getPrototypeOf(MdlTextFieldError)).apply(this, arguments));
    }

    _createClass(MdlTextFieldError, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlTextFieldError.prototype.__proto__ || Object.getPrototypeOf(MdlTextFieldError.prototype), 'oninit', this).call(this, vnode);
            this.classList.push("mdl-textfield__error");
        }
    }, {
        key: 'oncreate',
        value: function oncreate(vnode) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = Object.keys(vnode.attrs)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var attr = _step.value;

                    vnode.dom.setAttribute(attr, vnode.attrs[attr]);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        //for="username" noch integrieren?

    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                'span',
                { 'class': this.classList.join(" ") },
                vnode.attrs.text ? vnode.attrs.text : vnode.children
            );
        }
    }]);

    return MdlTextFieldError;
}(_mdlBase.MdlBase);

//https://stackoverflow.com/questions/14234560/javascript-how-to-get-parent-element-by-selector


function closest(el, selector, stopSelector) {
    var retval = null;
    el = el.parentElement; //changed to listen first to parents
    while (el) {
        if (el.className.indexOf(selector) > -1) {
            retval = el;
            break;
        } else if (stopSelector && el.className.indexOf(stopSelector) > -1) {
            break;
        }
        el = el.parentElement;
    }
    return retval;
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlToggle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlBase = __webpack_require__(1);

var _mdlButton = __webpack_require__(3);

var _mdlIcon = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MdlToggle = exports.MdlToggle = function (_MdlBase) {
    _inherits(MdlToggle, _MdlBase);

    function MdlToggle() {
        _classCallCheck(this, MdlToggle);

        var _this = _possibleConstructorReturn(this, (MdlToggle.__proto__ || Object.getPrototypeOf(MdlToggle)).call(this));

        _this.checked = false;
        return _this;
    }

    _createClass(MdlToggle, [{
        key: 'oninit',
        value: function oninit(vnode) {
            _get(MdlToggle.prototype.__proto__ || Object.getPrototypeOf(MdlToggle.prototype), 'oninit', this).call(this, vnode); // no classlist?

            this.colorActive = vnode.attrs.colorActive ? vnode.attrs.colorActive : "primary";
            this.colorInactive = vnode.attrs.colorInactive ? vnode.attrs.colorInactive : "grey";
            this.iconActive = vnode.attrs.iconActive ? vnode.attrs.iconActive : "check_box";
            this.iconInactive = vnode.attrs.iconInactive ? vnode.attrs.iconInactive : "check_box_outline_blank";

            this.checked = vnode.attrs.checked;
            this.oldAttrCheckedValue = vnode.attrs.checked;

            if (vnode.attrs.icon) {
                this.iconActive = vnode.attrs.icon;
                this.iconInactive = vnode.attrs.icon; //setting same for both
            }

            this.toggleInternal = false;
            this.initIcon();
        }
    }, {
        key: 'initIcon',
        value: function initIcon() {
            //console.log("init icon");

            if (this.checked) {
                this.icon = this.iconActive;
                this.color = this.colorActive;
            } else {
                this.icon = this.iconInactive;
                this.color = this.colorInactive;
            }
        }

        //onbefore update für old val und internal checked

    }, {
        key: 'onbeforeupdate',
        value: function onbeforeupdate(vnode, old) {
            //console.log("on before update");

            if (this.oldAttrCheckedValue != vnode.attrs.checked) {
                this.oldAttrCheckedValue = vnode.attrs.checked;
                this.checked = !this.checked;
            }

            if (this.toggleInternal) this.checked = !this.checked;

            this.toggleInternal = false;

            this.initIcon();

            return true;
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            var _this2 = this;

            return (0, _mithril2.default)(
                'div',
                null,
                (0, _mithril2.default)(
                    _mdlButton.MdlButton,
                    { icon: true, onclick: function onclick(e) {
                            _this2.toggleInternal = true;vnode.attrs.onclick ? vnode.attrs.onclick(e) : null;
                        } },
                    (0, _mithril2.default)(_mdlIcon.MdlIcon, { icon: this.icon, color: this.color })
                )
            );
        }
    }]);

    return MdlToggle;
}(_mdlBase.MdlBase);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MdlToolbar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mithril = __webpack_require__(0);

var _mithril2 = _interopRequireDefault(_mithril);

var _mdlLayout = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MdlToolbar = exports.MdlToolbar = function () {
    function MdlToolbar() {
        _classCallCheck(this, MdlToolbar);
    }

    _createClass(MdlToolbar, [{
        key: 'oninit',
        value: function oninit(vnode) {
            this.vnode = vnode;
        }
    }, {
        key: 'oncreate',
        value: function oncreate() {
            var mdToolbar = document.querySelector(".mdl-layout__header");
            mdToolbar.appendChild(this.vnode.dom);
        }
    }, {
        key: 'onremove',
        value: function onremove() {
            var mdToolbar = document.querySelector(".mdl-layout__header");
            if (mdToolbar && this.vnode.dom) mdToolbar.removeChild(this.vnode.dom);
        }
    }, {
        key: 'view',
        value: function view(vnode) {
            return (0, _mithril2.default)(
                _mdlLayout.MdlLayoutHeaderRow,
                null,
                vnode.children
            );
        }
    }]);

    return MdlToolbar;
}();

;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, "dialog{position:absolute;left:0;right:0;width:-moz-fit-content;width:-webkit-fit-content;width:fit-content;height:-moz-fit-content;height:-webkit-fit-content;height:fit-content;margin:auto;border:solid;padding:1em;background:#fff;color:#000;display:block}dialog:not([open]){display:none}dialog+.backdrop{background:rgba(0,0,0,.1)}._dialog_overlay,dialog+.backdrop{position:fixed;top:0;right:0;bottom:0;left:0}dialog.fixed{position:fixed;top:50%;transform:translateY(-50%)}", ""]);

// exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(7)(undefined);
// imports


// module
exports.push([module.i, ".mdl-list{padding:0;margin:0}.mdl-list .mdl-list__subheader{min-height:48px;padding:0 16px;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-flow:row wrap;flex-flow:row wrap;color:rgba(0,0,0,.54);font-size:14px;font-weight:500}.mdl-list .mdl-list__item.mdl-list__item--drop-down{position:relative;display:block}.mdl-list .mdl-list__item.mdl-list__item--drop-down .material-icons.toggle{position:absolute;top:12px;right:10px}.mdl-list .mdl-list__item.mdl-list__item--drop-down.in .mdl-list{display:none}.mdl-list .mdl-list__item.mdl-list__item--drop-down .mdl-list{margin-top:10px}.mdl-list__item-border{border-bottom:1px solid #d3d3d3}.mdl-layout__drawer{border-right:none}.mdl-list__item>.material-icons,.mdl-navigation__link>.material-icons{margin-right:10px}.mdl-navigation__link{flex:1}.mdl-layout__drawer .mdl-navigation{padding-top:0;flex-grow:1}form{display:flex;flex-direction:column}form .mdl-textfield{width:auto}.mdl-textfield--expandable .mdl-button--icon{top:17px}.mdl-list{width:100%}.mdl-list .mdl-list__item-primary-content .material-icons{margin-right:16px}.mdl-list__item--two-line .mdl-list__item-primary-content{height:auto}.mdl-layout__header-row>*{flex-shrink:1}.mdl-layout__header{user-select:none}.mdl-layout__header-row{padding:0 16px 0 60px}.mdl-layout__header-row .mdl-textfield__input{border-bottom:1px solid #fff}.mdl-card{min-height:10px;width:100%}.mdl-card .mdl-card__title{flex-direction:column}.mdl-card .mdl-card__title .mdl-card__title-text{align-self:flex-start}.mdl-card .mdl-card__title .mdl-card__subtitle-text{margin-top:6px;align-self:flex-start}.mdl-card .mdl-card__supporting-text{padding:0;width:100%}.mdl-tabs__tab{flex:1}.mdl-tabs__panel{padding:16px}.mdl-menu__item{display:flex}.mdl-menu__item .material-icons{align-self:center;margin-right:16px}.mdl-dialog__title{font-size:1.52rem}.mdl-layout__drawer-button:focus{outline:0}.mdl-data-table,.mdl-textfield{width:100%}.mdl-list__item{min-height:24px}.mdl-list__item--drop-down{align-items:flex-start}.mdl-list__item--drop-down .mdl-list__item-primary-content{flex-direction:column;align-items:flex-start;align-self:center}input[type=range]{margin:auto;outline:none;padding:0;width:100%;height:2px;background-color:#b4b6b6;background-image:-webkit-gradient(linear,50% 0,50% 100%,color-stop(0,#3f51b5),color-stop(100%,#b4b6b6));background-image:-webkit-linear-gradient(#3f51b5,#3f51b5);background-image:-moz-linear-gradient(#3f51b5,#3f51b5);background-image:-o-linear-gradient(#3f51b5,#3f51b5);background-image:linear-gradient(#3f51b5,#3f51b5);background-size:50% 100%;background-repeat:no-repeat;border-radius:0;cursor:pointer;-webkit-appearance:none}input[type=range]::-webkit-slider-runnable-track{box-shadow:none;border:none;background:transparent;-webkit-appearance:none}input[type=range]::-moz-range-track{box-shadow:none;border:none;background:#3f51b5}input[type=range]::-moz-focus-outer{border:0}input[type=range]::-webkit-slider-thumb{width:14px;height:14px;border:0;background:#3f51b5;border-radius:100%;box-shadow:0 0 1px 0 rgba(0,0,0,.1);-webkit-appearance:none}input[type=range]::-moz-range-thumb{width:14px;height:14px;border:0;background:#fff;border-radius:100%;box-shadow:0 0 1px 0 rgba(0,0,0,.1)}", ""]);

// exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(function() {

  // nb. This is for IE10 and lower _only_.
  var supportCustomEvent = window.CustomEvent;
  if (!supportCustomEvent || typeof supportCustomEvent === 'object') {
    supportCustomEvent = function CustomEvent(event, x) {
      x = x || {};
      var ev = document.createEvent('CustomEvent');
      ev.initCustomEvent(event, !!x.bubbles, !!x.cancelable, x.detail || null);
      return ev;
    };
    supportCustomEvent.prototype = window.Event.prototype;
  }

  /**
   * @param {Element} el to check for stacking context
   * @return {boolean} whether this el or its parents creates a stacking context
   */
  function createsStackingContext(el) {
    while (el && el !== document.body) {
      var s = window.getComputedStyle(el);
      var invalid = function(k, ok) {
        return !(s[k] === undefined || s[k] === ok);
      }
      if (s.opacity < 1 ||
          invalid('zIndex', 'auto') ||
          invalid('transform', 'none') ||
          invalid('mixBlendMode', 'normal') ||
          invalid('filter', 'none') ||
          invalid('perspective', 'none') ||
          s['isolation'] === 'isolate' ||
          s.position === 'fixed' ||
          s.webkitOverflowScrolling === 'touch') {
        return true;
      }
      el = el.parentElement;
    }
    return false;
  }

  /**
   * Finds the nearest <dialog> from the passed element.
   *
   * @param {Element} el to search from
   * @return {HTMLDialogElement} dialog found
   */
  function findNearestDialog(el) {
    while (el) {
      if (el.localName === 'dialog') {
        return /** @type {HTMLDialogElement} */ (el);
      }
      el = el.parentElement;
    }
    return null;
  }

  /**
   * Blur the specified element, as long as it's not the HTML body element.
   * This works around an IE9/10 bug - blurring the body causes Windows to
   * blur the whole application.
   *
   * @param {Element} el to blur
   */
  function safeBlur(el) {
    if (el && el.blur && el !== document.body) {
      el.blur();
    }
  }

  /**
   * @param {!NodeList} nodeList to search
   * @param {Node} node to find
   * @return {boolean} whether node is inside nodeList
   */
  function inNodeList(nodeList, node) {
    for (var i = 0; i < nodeList.length; ++i) {
      if (nodeList[i] === node) {
        return true;
      }
    }
    return false;
  }

  /**
   * @param {HTMLFormElement} el to check
   * @return {boolean} whether this form has method="dialog"
   */
  function isFormMethodDialog(el) {
    if (!el || !el.hasAttribute('method')) {
      return false;
    }
    return el.getAttribute('method').toLowerCase() === 'dialog';
  }

  /**
   * @param {!HTMLDialogElement} dialog to upgrade
   * @constructor
   */
  function dialogPolyfillInfo(dialog) {
    this.dialog_ = dialog;
    this.replacedStyleTop_ = false;
    this.openAsModal_ = false;

    // Set a11y role. Browsers that support dialog implicitly know this already.
    if (!dialog.hasAttribute('role')) {
      dialog.setAttribute('role', 'dialog');
    }

    dialog.show = this.show.bind(this);
    dialog.showModal = this.showModal.bind(this);
    dialog.close = this.close.bind(this);

    if (!('returnValue' in dialog)) {
      dialog.returnValue = '';
    }

    if ('MutationObserver' in window) {
      var mo = new MutationObserver(this.maybeHideModal.bind(this));
      mo.observe(dialog, {attributes: true, attributeFilter: ['open']});
    } else {
      // IE10 and below support. Note that DOMNodeRemoved etc fire _before_ removal. They also
      // seem to fire even if the element was removed as part of a parent removal. Use the removed
      // events to force downgrade (useful if removed/immediately added).
      var removed = false;
      var cb = function() {
        removed ? this.downgradeModal() : this.maybeHideModal();
        removed = false;
      }.bind(this);
      var timeout;
      var delayModel = function(ev) {
        if (ev.target !== dialog) { return; }  // not for a child element
        var cand = 'DOMNodeRemoved';
        removed |= (ev.type.substr(0, cand.length) === cand);
        window.clearTimeout(timeout);
        timeout = window.setTimeout(cb, 0);
      };
      ['DOMAttrModified', 'DOMNodeRemoved', 'DOMNodeRemovedFromDocument'].forEach(function(name) {
        dialog.addEventListener(name, delayModel);
      });
    }
    // Note that the DOM is observed inside DialogManager while any dialog
    // is being displayed as a modal, to catch modal removal from the DOM.

    Object.defineProperty(dialog, 'open', {
      set: this.setOpen.bind(this),
      get: dialog.hasAttribute.bind(dialog, 'open')
    });

    this.backdrop_ = document.createElement('div');
    this.backdrop_.className = 'backdrop';
    this.backdrop_.addEventListener('click', this.backdropClick_.bind(this));
  }

  dialogPolyfillInfo.prototype = {

    get dialog() {
      return this.dialog_;
    },

    /**
     * Maybe remove this dialog from the modal top layer. This is called when
     * a modal dialog may no longer be tenable, e.g., when the dialog is no
     * longer open or is no longer part of the DOM.
     */
    maybeHideModal: function() {
      if (this.dialog_.hasAttribute('open') && document.body.contains(this.dialog_)) { return; }
      this.downgradeModal();
    },

    /**
     * Remove this dialog from the modal top layer, leaving it as a non-modal.
     */
    downgradeModal: function() {
      if (!this.openAsModal_) { return; }
      this.openAsModal_ = false;
      this.dialog_.style.zIndex = '';

      // This won't match the native <dialog> exactly because if the user set top on a centered
      // polyfill dialog, that top gets thrown away when the dialog is closed. Not sure it's
      // possible to polyfill this perfectly.
      if (this.replacedStyleTop_) {
        this.dialog_.style.top = '';
        this.replacedStyleTop_ = false;
      }

      // Clear the backdrop and remove from the manager.
      this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_);
      dialogPolyfill.dm.removeDialog(this);
    },

    /**
     * @param {boolean} value whether to open or close this dialog
     */
    setOpen: function(value) {
      if (value) {
        this.dialog_.hasAttribute('open') || this.dialog_.setAttribute('open', '');
      } else {
        this.dialog_.removeAttribute('open');
        this.maybeHideModal();  // nb. redundant with MutationObserver
      }
    },

    /**
     * Handles clicks on the fake .backdrop element, redirecting them as if
     * they were on the dialog itself.
     *
     * @param {!Event} e to redirect
     */
    backdropClick_: function(e) {
      if (!this.dialog_.hasAttribute('tabindex')) {
        // Clicking on the backdrop should move the implicit cursor, even if dialog cannot be
        // focused. Create a fake thing to focus on. If the backdrop was _before_ the dialog, this
        // would not be needed - clicks would move the implicit cursor there.
        var fake = document.createElement('div');
        this.dialog_.insertBefore(fake, this.dialog_.firstChild);
        fake.tabIndex = -1;
        fake.focus();
        this.dialog_.removeChild(fake);
      } else {
        this.dialog_.focus();
      }

      var redirectedEvent = document.createEvent('MouseEvents');
      redirectedEvent.initMouseEvent(e.type, e.bubbles, e.cancelable, window,
          e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey,
          e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
      this.dialog_.dispatchEvent(redirectedEvent);
      e.stopPropagation();
    },

    /**
     * Focuses on the first focusable element within the dialog. This will always blur the current
     * focus, even if nothing within the dialog is found.
     */
    focus_: function() {
      // Find element with `autofocus` attribute, or fall back to the first form/tabindex control.
      var target = this.dialog_.querySelector('[autofocus]:not([disabled])');
      if (!target && this.dialog_.tabIndex >= 0) {
        target = this.dialog_;
      }
      if (!target) {
        // Note that this is 'any focusable area'. This list is probably not exhaustive, but the
        // alternative involves stepping through and trying to focus everything.
        var opts = ['button', 'input', 'keygen', 'select', 'textarea'];
        var query = opts.map(function(el) {
          return el + ':not([disabled])';
        });
        // TODO(samthor): tabindex values that are not numeric are not focusable.
        query.push('[tabindex]:not([disabled]):not([tabindex=""])');  // tabindex != "", not disabled
        target = this.dialog_.querySelector(query.join(', '));
      }
      safeBlur(document.activeElement);
      target && target.focus();
    },

    /**
     * Sets the zIndex for the backdrop and dialog.
     *
     * @param {number} dialogZ
     * @param {number} backdropZ
     */
    updateZIndex: function(dialogZ, backdropZ) {
      if (dialogZ < backdropZ) {
        throw new Error('dialogZ should never be < backdropZ');
      }
      this.dialog_.style.zIndex = dialogZ;
      this.backdrop_.style.zIndex = backdropZ;
    },

    /**
     * Shows the dialog. If the dialog is already open, this does nothing.
     */
    show: function() {
      if (!this.dialog_.open) {
        this.setOpen(true);
        this.focus_();
      }
    },

    /**
     * Show this dialog modally.
     */
    showModal: function() {
      if (this.dialog_.hasAttribute('open')) {
        throw new Error('Failed to execute \'showModal\' on dialog: The element is already open, and therefore cannot be opened modally.');
      }
      if (!document.body.contains(this.dialog_)) {
        throw new Error('Failed to execute \'showModal\' on dialog: The element is not in a Document.');
      }
      if (!dialogPolyfill.dm.pushDialog(this)) {
        throw new Error('Failed to execute \'showModal\' on dialog: There are too many open modal dialogs.');
      }

      if (createsStackingContext(this.dialog_.parentElement)) {
        console.warn('A dialog is being shown inside a stacking context. ' +
            'This may cause it to be unusable. For more information, see this link: ' +
            'https://github.com/GoogleChrome/dialog-polyfill/#stacking-context');
      }

      this.setOpen(true);
      this.openAsModal_ = true;

      // Optionally center vertically, relative to the current viewport.
      if (dialogPolyfill.needsCentering(this.dialog_)) {
        dialogPolyfill.reposition(this.dialog_);
        this.replacedStyleTop_ = true;
      } else {
        this.replacedStyleTop_ = false;
      }

      // Insert backdrop.
      this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling);

      // Focus on whatever inside the dialog.
      this.focus_();
    },

    /**
     * Closes this HTMLDialogElement. This is optional vs clearing the open
     * attribute, however this fires a 'close' event.
     *
     * @param {string=} opt_returnValue to use as the returnValue
     */
    close: function(opt_returnValue) {
      if (!this.dialog_.hasAttribute('open')) {
        throw new Error('Failed to execute \'close\' on dialog: The element does not have an \'open\' attribute, and therefore cannot be closed.');
      }
      this.setOpen(false);

      // Leave returnValue untouched in case it was set directly on the element
      if (opt_returnValue !== undefined) {
        this.dialog_.returnValue = opt_returnValue;
      }

      // Triggering "close" event for any attached listeners on the <dialog>.
      var closeEvent = new supportCustomEvent('close', {
        bubbles: false,
        cancelable: false
      });
      this.dialog_.dispatchEvent(closeEvent);
    }

  };

  var dialogPolyfill = {};

  dialogPolyfill.reposition = function(element) {
    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    var topValue = scrollTop + (window.innerHeight - element.offsetHeight) / 2;
    element.style.top = Math.max(scrollTop, topValue) + 'px';
  };

  dialogPolyfill.isInlinePositionSetByStylesheet = function(element) {
    for (var i = 0; i < document.styleSheets.length; ++i) {
      var styleSheet = document.styleSheets[i];
      var cssRules = null;
      // Some browsers throw on cssRules.
      try {
        cssRules = styleSheet.cssRules;
      } catch (e) {}
      if (!cssRules) { continue; }
      for (var j = 0; j < cssRules.length; ++j) {
        var rule = cssRules[j];
        var selectedNodes = null;
        // Ignore errors on invalid selector texts.
        try {
          selectedNodes = document.querySelectorAll(rule.selectorText);
        } catch(e) {}
        if (!selectedNodes || !inNodeList(selectedNodes, element)) {
          continue;
        }
        var cssTop = rule.style.getPropertyValue('top');
        var cssBottom = rule.style.getPropertyValue('bottom');
        if ((cssTop && cssTop !== 'auto') || (cssBottom && cssBottom !== 'auto')) {
          return true;
        }
      }
    }
    return false;
  };

  dialogPolyfill.needsCentering = function(dialog) {
    var computedStyle = window.getComputedStyle(dialog);
    if (computedStyle.position !== 'absolute') {
      return false;
    }

    // We must determine whether the top/bottom specified value is non-auto.  In
    // WebKit/Blink, checking computedStyle.top == 'auto' is sufficient, but
    // Firefox returns the used value. So we do this crazy thing instead: check
    // the inline style and then go through CSS rules.
    if ((dialog.style.top !== 'auto' && dialog.style.top !== '') ||
        (dialog.style.bottom !== 'auto' && dialog.style.bottom !== '')) {
      return false;
    }
    return !dialogPolyfill.isInlinePositionSetByStylesheet(dialog);
  };

  /**
   * @param {!Element} element to force upgrade
   */
  dialogPolyfill.forceRegisterDialog = function(element) {
    if (window.HTMLDialogElement || element.showModal) {
      console.warn('This browser already supports <dialog>, the polyfill ' +
          'may not work correctly', element);
    }
    if (element.localName !== 'dialog') {
      throw new Error('Failed to register dialog: The element is not a dialog.');
    }
    new dialogPolyfillInfo(/** @type {!HTMLDialogElement} */ (element));
  };

  /**
   * @param {!Element} element to upgrade, if necessary
   */
  dialogPolyfill.registerDialog = function(element) {
    if (!element.showModal) {
      dialogPolyfill.forceRegisterDialog(element);
    }
  };

  /**
   * @constructor
   */
  dialogPolyfill.DialogManager = function() {
    /** @type {!Array<!dialogPolyfillInfo>} */
    this.pendingDialogStack = [];

    var checkDOM = this.checkDOM_.bind(this);

    // The overlay is used to simulate how a modal dialog blocks the document.
    // The blocking dialog is positioned on top of the overlay, and the rest of
    // the dialogs on the pending dialog stack are positioned below it. In the
    // actual implementation, the modal dialog stacking is controlled by the
    // top layer, where z-index has no effect.
    this.overlay = document.createElement('div');
    this.overlay.className = '_dialog_overlay';
    this.overlay.addEventListener('click', function(e) {
      this.forwardTab_ = undefined;
      e.stopPropagation();
      checkDOM([]);  // sanity-check DOM
    }.bind(this));

    this.handleKey_ = this.handleKey_.bind(this);
    this.handleFocus_ = this.handleFocus_.bind(this);

    this.zIndexLow_ = 100000;
    this.zIndexHigh_ = 100000 + 150;

    this.forwardTab_ = undefined;

    if ('MutationObserver' in window) {
      this.mo_ = new MutationObserver(function(records) {
        var removed = [];
        records.forEach(function(rec) {
          for (var i = 0, c; c = rec.removedNodes[i]; ++i) {
            if (!(c instanceof Element)) {
              continue;
            } else if (c.localName === 'dialog') {
              removed.push(c);
            }
            removed = removed.concat(c.querySelectorAll('dialog'));
          }
        });
        removed.length && checkDOM(removed);
      });
    }
  };

  /**
   * Called on the first modal dialog being shown. Adds the overlay and related
   * handlers.
   */
  dialogPolyfill.DialogManager.prototype.blockDocument = function() {
    document.documentElement.addEventListener('focus', this.handleFocus_, true);
    document.addEventListener('keydown', this.handleKey_);
    this.mo_ && this.mo_.observe(document, {childList: true, subtree: true});
  };

  /**
   * Called on the first modal dialog being removed, i.e., when no more modal
   * dialogs are visible.
   */
  dialogPolyfill.DialogManager.prototype.unblockDocument = function() {
    document.documentElement.removeEventListener('focus', this.handleFocus_, true);
    document.removeEventListener('keydown', this.handleKey_);
    this.mo_ && this.mo_.disconnect();
  };

  /**
   * Updates the stacking of all known dialogs.
   */
  dialogPolyfill.DialogManager.prototype.updateStacking = function() {
    var zIndex = this.zIndexHigh_;

    for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
      dpi.updateZIndex(--zIndex, --zIndex);
      if (i === 0) {
        this.overlay.style.zIndex = --zIndex;
      }
    }

    // Make the overlay a sibling of the dialog itself.
    var last = this.pendingDialogStack[0];
    if (last) {
      var p = last.dialog.parentNode || document.body;
      p.appendChild(this.overlay);
    } else if (this.overlay.parentNode) {
      this.overlay.parentNode.removeChild(this.overlay);
    }
  };

  /**
   * @param {Element} candidate to check if contained or is the top-most modal dialog
   * @return {boolean} whether candidate is contained in top dialog
   */
  dialogPolyfill.DialogManager.prototype.containedByTopDialog_ = function(candidate) {
    while (candidate = findNearestDialog(candidate)) {
      for (var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i) {
        if (dpi.dialog === candidate) {
          return i === 0;  // only valid if top-most
        }
      }
      candidate = candidate.parentElement;
    }
    return false;
  };

  dialogPolyfill.DialogManager.prototype.handleFocus_ = function(event) {
    if (this.containedByTopDialog_(event.target)) { return; }

    event.preventDefault();
    event.stopPropagation();
    safeBlur(/** @type {Element} */ (event.target));

    if (this.forwardTab_ === undefined) { return; }  // move focus only from a tab key

    var dpi = this.pendingDialogStack[0];
    var dialog = dpi.dialog;
    var position = dialog.compareDocumentPosition(event.target);
    if (position & Node.DOCUMENT_POSITION_PRECEDING) {
      if (this.forwardTab_) {  // forward
        dpi.focus_();
      } else {  // backwards
        document.documentElement.focus();
      }
    } else {
      // TODO: Focus after the dialog, is ignored.
    }

    return false;
  };

  dialogPolyfill.DialogManager.prototype.handleKey_ = function(event) {
    this.forwardTab_ = undefined;
    if (event.keyCode === 27) {
      event.preventDefault();
      event.stopPropagation();
      var cancelEvent = new supportCustomEvent('cancel', {
        bubbles: false,
        cancelable: true
      });
      var dpi = this.pendingDialogStack[0];
      if (dpi && dpi.dialog.dispatchEvent(cancelEvent)) {
        dpi.dialog.close();
      }
    } else if (event.keyCode === 9) {
      this.forwardTab_ = !event.shiftKey;
    }
  };

  /**
   * Finds and downgrades any known modal dialogs that are no longer displayed. Dialogs that are
   * removed and immediately readded don't stay modal, they become normal.
   *
   * @param {!Array<!HTMLDialogElement>} removed that have definitely been removed
   */
  dialogPolyfill.DialogManager.prototype.checkDOM_ = function(removed) {
    // This operates on a clone because it may cause it to change. Each change also calls
    // updateStacking, which only actually needs to happen once. But who removes many modal dialogs
    // at a time?!
    var clone = this.pendingDialogStack.slice();
    clone.forEach(function(dpi) {
      if (removed.indexOf(dpi.dialog) !== -1) {
        dpi.downgradeModal();
      } else {
        dpi.maybeHideModal();
      }
    });
  };

  /**
   * @param {!dialogPolyfillInfo} dpi
   * @return {boolean} whether the dialog was allowed
   */
  dialogPolyfill.DialogManager.prototype.pushDialog = function(dpi) {
    var allowed = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
    if (this.pendingDialogStack.length >= allowed) {
      return false;
    }
    if (this.pendingDialogStack.unshift(dpi) === 1) {
      this.blockDocument();
    }
    this.updateStacking();
    return true;
  };

  /**
   * @param {!dialogPolyfillInfo} dpi
   */
  dialogPolyfill.DialogManager.prototype.removeDialog = function(dpi) {
    var index = this.pendingDialogStack.indexOf(dpi);
    if (index === -1) { return; }

    this.pendingDialogStack.splice(index, 1);
    if (this.pendingDialogStack.length === 0) {
      this.unblockDocument();
    }
    this.updateStacking();
  };

  dialogPolyfill.dm = new dialogPolyfill.DialogManager();
  dialogPolyfill.formSubmitter = null;
  dialogPolyfill.useValue = null;

  /**
   * Installs global handlers, such as click listers and native method overrides. These are needed
   * even if a no dialog is registered, as they deal with <form method="dialog">.
   */
  if (window.HTMLDialogElement === undefined) {

    /**
     * If HTMLFormElement translates method="DIALOG" into 'get', then replace the descriptor with
     * one that returns the correct value.
     */
    var testForm = document.createElement('form');
    testForm.setAttribute('method', 'dialog');
    if (testForm.method !== 'dialog') {
      var methodDescriptor = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, 'method');
      var realGet = methodDescriptor.get;
      methodDescriptor.get = function() {
        if (isFormMethodDialog(this)) {
          return 'dialog';
        }
        return realGet.call(this);
      };
      var realSet = methodDescriptor.set;
      methodDescriptor.set = function(v) {
        if (typeof v === 'string' && v.toLowerCase() === 'dialog') {
          return this.setAttribute('method', v);
        }
        return realSet.call(this, v);
      };
      Object.defineProperty(HTMLFormElement.prototype, 'method', methodDescriptor);
    }

    /**
     * Global 'click' handler, to capture the <input type="submit"> or <button> element which has
     * submitted a <form method="dialog">. Needed as Safari and others don't report this inside
     * document.activeElement.
     */
    document.addEventListener('click', function(ev) {
      dialogPolyfill.formSubmitter = null;
      dialogPolyfill.useValue = null;
      if (ev.defaultPrevented) { return; }  // e.g. a submit which prevents default submission

      var target = /** @type {Element} */ (ev.target);
      if (!target || !isFormMethodDialog(target.form)) { return; }

      var valid = (target.type === 'submit' && ['button', 'input'].indexOf(target.localName) > -1);
      if (!valid) {
        if (!(target.localName === 'input' && target.type === 'image')) { return; }
        // this is a <input type="image">, which can submit forms
        dialogPolyfill.useValue = ev.offsetX + ',' + ev.offsetY;
      }

      var dialog = findNearestDialog(target);
      if (!dialog) { return; }

      dialogPolyfill.formSubmitter = target;
    }, false);

    /**
     * Replace the native HTMLFormElement.submit() method, as it won't fire the
     * submit event and give us a chance to respond.
     */
    var nativeFormSubmit = HTMLFormElement.prototype.submit;
    function replacementFormSubmit() {
      if (!isFormMethodDialog(this)) {
        return nativeFormSubmit.call(this);
      }
      var dialog = findNearestDialog(this);
      dialog && dialog.close();
    }
    HTMLFormElement.prototype.submit = replacementFormSubmit;

    /**
     * Global form 'dialog' method handler. Closes a dialog correctly on submit
     * and possibly sets its return value.
     */
    document.addEventListener('submit', function(ev) {
      var form = /** @type {HTMLFormElement} */ (ev.target);
      if (!isFormMethodDialog(form)) { return; }
      ev.preventDefault();

      var dialog = findNearestDialog(form);
      if (!dialog) { return; }

      // Forms can only be submitted via .submit() or a click (?), but anyway: sanity-check that
      // the submitter is correct before using its value as .returnValue.
      var s = dialogPolyfill.formSubmitter;
      if (s && s.form === form) {
        dialog.close(dialogPolyfill.useValue || s.value);
      } else {
        dialog.close();
      }
      dialogPolyfill.formSubmitter = null;
    }, true);
  }

  dialogPolyfill['forceRegisterDialog'] = dialogPolyfill.forceRegisterDialog;
  dialogPolyfill['registerDialog'] = dialogPolyfill.registerDialog;

  if ("function" === 'function' && 'amd' in __webpack_require__(29)) {
    // AMD support
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() { return dialogPolyfill; }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && typeof module['exports'] === 'object') {
    // CommonJS support
    module['exports'] = dialogPolyfill;
  } else {
    // all others
    window['dialogPolyfill'] = dialogPolyfill;
  }
})();


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(23);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!./dialog-polyfill.css", function() {
			var newContent = require("!!../css-loader/index.js!./dialog-polyfill.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(24);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(8)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./mdl.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./mdl.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 28 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(9);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// mithrilmdl.js